export const STANDARD_TANK_ARMOR_PROFILES = {
    mbt_standard: {
        tankClassId: 'mbt_standard',
        name: 'T-72M Main Battle Tank Armor Scheme',
        zones: [
            {
                armorId: 'upper_glacis',
                name: 'Upper Front Plate (Glacis)',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 215,
                normalLocal: { x: 0, y: 0.88, z: 0.47 }, // 68° sloped plate
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 45, particleCount: 6, damageFraction: 0.3 },
                layers: [
                    { layerIndex: 0, materialId: 'steel', thicknessMm: 60, airGapMm: 0 },
                    { layerIndex: 1, materialId: 'composite', thicknessMm: 105, airGapMm: 0 },
                    { layerIndex: 2, materialId: 'steel', thicknessMm: 50, airGapMm: 0 },
                ],
                boundsLocal: {
                    min: { x: -1.3, y: 0.4, z: 1.5 },
                    max: { x: 1.3, y: 1.2, z: 3.2 },
                },
            },
            {
                armorId: 'lower_front_plate',
                name: 'Lower Front Plate',
                armorType: 'sloped',
                materialId: 'steel',
                thicknessMm: 85,
                normalLocal: { x: 0, y: -0.5, z: 0.866 }, // 30° downward slope
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 55, particleCount: 8, damageFraction: 0.4 },
                boundsLocal: {
                    min: { x: -1.2, y: 0.0, z: 2.8 },
                    max: { x: 1.2, y: 0.5, z: 3.4 },
                },
            },
            {
                armorId: 'turret_cheeks',
                name: 'Turret Frontal Cheeks',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 410,
                normalLocal: { x: 0, y: 0.1, z: 0.99 },
                surfaceGeometry: 'curved',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 35, particleCount: 4, damageFraction: 0.2 },
                boundsLocal: {
                    min: { x: -1.1, y: 1.2, z: 0.2 },
                    max: { x: 1.1, y: 2.1, z: 1.6 },
                },
            },
            {
                armorId: 'turret_mantlet',
                name: 'Gun Mantlet',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 350,
                normalLocal: { x: 0, y: 0, z: 1.0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 40, particleCount: 5, damageFraction: 0.25 },
                boundsLocal: {
                    min: { x: -0.4, y: 1.4, z: 1.4 },
                    max: { x: 0.4, y: 1.9, z: 1.9 },
                },
            },
            {
                armorId: 'hull_side_upper',
                name: 'Side Hull Armor',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 80,
                normalLocal: { x: 1.0, y: 0, z: 0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 60, particleCount: 8, damageFraction: 0.5 },
                boundsLocal: {
                    min: { x: 1.2, y: 0.4, z: -2.8 },
                    max: { x: 1.4, y: 1.2, z: 1.8 },
                },
            },
            {
                armorId: 'turret_side',
                name: 'Turret Flank Armor',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 110,
                normalLocal: { x: 1.0, y: 0.1, z: 0 },
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 50, particleCount: 6, damageFraction: 0.4 },
                boundsLocal: {
                    min: { x: 1.0, y: 1.2, z: -1.0 },
                    max: { x: 1.3, y: 2.0, z: 0.5 },
                },
            },
            {
                armorId: 'rear_hull',
                name: 'Rear Engine Deck & Exhaust',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 45,
                normalLocal: { x: 0, y: 0, z: -1.0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 70, particleCount: 10, damageFraction: 0.6 },
                boundsLocal: {
                    min: { x: -1.2, y: 0.3, z: -3.2 },
                    max: { x: 1.2, y: 1.1, z: -2.8 },
                },
            },
            {
                armorId: 'roof_armor',
                name: 'Turret & Hull Top Roof',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 30,
                normalLocal: { x: 0, y: 1.0, z: 0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 65, particleCount: 8, damageFraction: 0.5 },
                boundsLocal: {
                    min: { x: -1.2, y: 1.9, z: -1.2 },
                    max: { x: 1.2, y: 2.2, z: 1.2 },
                },
            },
        ],
    },
    leopard_2: {
        tankClassId: 'leopard_2',
        name: 'Leopard 2A4 Armor Scheme',
        zones: [
            {
                armorId: 'upper_glacis',
                name: 'Upper Front Plate',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 240,
                normalLocal: { x: 0, y: 0.85, z: 0.52 },
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 40, particleCount: 5, damageFraction: 0.25 },
                layers: [
                    { layerIndex: 0, materialId: 'steel', thicknessMm: 80, airGapMm: 0 },
                    { layerIndex: 1, materialId: 'composite', thicknessMm: 120, airGapMm: 0 },
                    { layerIndex: 2, materialId: 'steel', thicknessMm: 40, airGapMm: 0 },
                ],
            },
            {
                armorId: 'turret_cheeks',
                name: 'Vertical Wedge Cheeks',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 450,
                normalLocal: { x: 0.2, y: 0.0, z: 0.98 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 30, particleCount: 4, damageFraction: 0.15 },
            },
            {
                armorId: 'hull_side_upper',
                name: 'Side Skirts & Hull',
                armorType: 'spaced',
                materialId: 'steel',
                thicknessMm: 70,
                normalLocal: { x: 1.0, y: 0, z: 0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 55, particleCount: 7, damageFraction: 0.4 },
                layers: [
                    { layerIndex: 0, materialId: 'rubber', thicknessMm: 15, airGapMm: 200 },
                    { layerIndex: 1, materialId: 'steel', thicknessMm: 55, airGapMm: 0 },
                ],
            },
            {
                armorId: 'rear_hull',
                name: 'Engine Compartment Rear',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 40,
                normalLocal: { x: 0, y: 0, z: -1.0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 70, particleCount: 10, damageFraction: 0.6 },
            },
        ],
    },
    abrams_m1: {
        tankClassId: 'abrams_m1',
        name: 'M1A1 Abrams Chobham Armor Scheme',
        zones: [
            {
                armorId: 'upper_glacis',
                name: 'Extreme Sloped Glacis',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 180,
                normalLocal: { x: 0, y: 0.95, z: 0.31 }, // 72° extreme slope
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 35, particleCount: 4, damageFraction: 0.2 },
            },
            {
                armorId: 'turret_cheeks',
                name: 'Heavy Chobham Turret Front',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 480,
                normalLocal: { x: 0.15, y: 0.05, z: 0.98 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 25, particleCount: 3, damageFraction: 0.15 },
            },
            {
                armorId: 'lower_front_plate',
                name: 'Lower Glacis Plate',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 120,
                normalLocal: { x: 0, y: -0.4, z: 0.916 },
                surfaceGeometry: 'sloped',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 50, particleCount: 6, damageFraction: 0.35 },
            },
            {
                armorId: 'hull_side_upper',
                name: 'Side Heavy Skirts',
                armorType: 'composite',
                materialId: 'composite',
                thicknessMm: 90,
                normalLocal: { x: 1.0, y: 0, z: 0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 50, particleCount: 6, damageFraction: 0.35 },
            },
            {
                armorId: 'rear_hull',
                name: 'Turbine Exhaust Rear',
                armorType: 'homogeneous',
                materialId: 'steel',
                thicknessMm: 40,
                normalLocal: { x: 0, y: 0, z: -1.0 },
                surfaceGeometry: 'flat',
                durability: 1.0,
                isPenetrable: true,
                spallBehavior: { coneAngleDeg: 70, particleCount: 10, damageFraction: 0.6 },
            },
        ],
    },
};
export function getTankArmorProfile(tankClassId) {
    return (STANDARD_TANK_ARMOR_PROFILES[tankClassId] ||
        STANDARD_TANK_ARMOR_PROFILES.mbt_standard);
}
//# sourceMappingURL=tank-armor-profile.js.map